var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 2.82617C7.80968 2.6898 8.19032 2.6898 8.53125 2.82617L11.9434 4.19141C12.2372 4.30907 12.4297 4.5936 12.4297 4.91016V6.39062C12.4296 9.05012 11.0344 11.5145 8.75391 12.8828C8.28984 13.1613 7.71016 13.1613 7.24609 12.8828C4.96558 11.5145 3.57043 9.05012 3.57031 6.39062V4.91016C3.57035 4.5936 3.76278 4.30907 4.05664 4.19141L7.46875 2.82617Z",
    stroke: "#002A69",
    strokeWidth: 1.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldOutline);
export default __webpack_public_path__ + "static/media/Shield_outline.89ae0b92c637647278d96d0327efaaad.svg";
export { ForwardRef as ReactComponent };